module.exports = __webpack_public_path__ + "img/yt.5697f90b.svg";